module.exports = __webpack_public_path__ + "img/siguenos-rrss-web-entradas-512x301-ES.3ab33e68.jpg";